document.addEventListener('DOMContentLoaded', function() {
    console.log('Product Highlight 3 - Script loaded');
    
    // Track initialized elements to prevent duplicate initialization
    const initializedSections = new WeakSet();
    const initializedVideos = new WeakSet();
    
    // Initialize accordion functionality for product highlight sections
    function initProductHighlightAccordion() {
      const accordionSections = document.querySelectorAll('.tpt-product-highlight-3');
      console.log('Found accordion sections:', accordionSections.length);
      
      accordionSections.forEach((section, sectionIndex) => {
        // Skip if already initialized
        if (initializedSections.has(section)) {
          console.log('Section', sectionIndex, 'already initialized, skipping');
          return;
        }
        
        console.log('Initializing section', sectionIndex);
        const accordionItems = section.querySelectorAll('.tpt-product-highlight-3_accordion-item');
        
        accordionItems.forEach((item, itemIndex) => {
          const header = item.querySelector('.tpt-product-highlight-3_accordion-header');
          const content = item.querySelector('.tpt-product-highlight-3_accordion-content');
          
          if (header && content) {
            // Remove any existing event listeners to prevent duplicates
            const existingHandler = header._accordionClickHandler;
            if (existingHandler) {
              header.removeEventListener('click', existingHandler);
            }
            
            // Set initial max-height for active items
            if (item.classList.contains('active')) {
              setContentHeight(content, true);
            }
            
            // Create a unique handler for this specific item
            const clickHandler = function(event) {
              event.preventDefault();
              event.stopPropagation();
              
              console.log('Accordion clicked - Section:', sectionIndex, 'Item:', itemIndex);
              
              const isCurrentlyActive = item.classList.contains('active');
              
              // Close all accordion items in THIS section only
              const sectionItems = section.querySelectorAll('.tpt-product-highlight-3_accordion-item');
              sectionItems.forEach(otherItem => {
                if (otherItem !== item) {
                  otherItem.classList.remove('active');
                  const otherContent = otherItem.querySelector('.tpt-product-highlight-3_accordion-content');
                  if (otherContent) {
                    setContentHeight(otherContent, false);
                  }
                }
              });
              
              // Toggle current item
              if (isCurrentlyActive) {
                item.classList.remove('active');
                setContentHeight(content, false);
              } else {
                item.classList.add('active');
                setContentHeight(content, true);
              }
            };
            
            // Store the handler reference and add event listener
            header._accordionClickHandler = clickHandler;
            header.addEventListener('click', clickHandler);
            
            console.log('Accordion handler attached for section', sectionIndex, 'item', itemIndex);
          }
        });
        
        // Mark section as initialized
        initializedSections.add(section);
        console.log('Section', sectionIndex, 'accordion initialized');
      });
    }
    
    // Set content height for smooth animation
    function setContentHeight(content, isOpen) {
      if (isOpen) {
        const textElement = content.querySelector('.tpt-product-highlight-3_accordion-text');
        if (textElement) {
          const scrollHeight = textElement.scrollHeight;
          content.style.maxHeight = (scrollHeight + 40) + 'px'; // Add padding
        }
      } else {
        content.style.maxHeight = '0px';
      }
    }
    
    // Handle video elements for each section independently
    function initVideoForSection(section, sectionIndex) {
      console.log('Initializing video for section', sectionIndex);
      
      const videoContainer = section.querySelector('.tpt-product-highlight-3_video-container');
      if (!videoContainer) {
        console.log('No video container found in section', sectionIndex);
        return;
      }
      
      // Skip if already initialized
      if (initializedVideos.has(videoContainer)) {
        console.log('Video in section', sectionIndex, 'already initialized');
        return;
      }
      
      const video = videoContainer.querySelector('video');
      const playPauseBtn = videoContainer.querySelector('.tpt-product-highlight-3_play-pause-btn');
      
      if (!video || !playPauseBtn) {
        console.log('Video or play button not found in section', sectionIndex);
        return;
      }
      
      console.log('Setting up video controls for section', sectionIndex);
      
      // Add unique identifier
      const uniqueId = 'video_section_' + sectionIndex + '_' + Date.now();
      videoContainer.setAttribute('data-video-id', uniqueId);
      
      // Initialize video state
      function updateVideoState() {
        if (video.paused || video.ended) {
          videoContainer.classList.add('paused');
        } else {
          videoContainer.classList.remove('paused');
        }
      }
      
      // Pause all other videos on the page
      function pauseOtherVideos() {
        const allVideoContainers = document.querySelectorAll('.tpt-product-highlight-3_video-container');
        allVideoContainers.forEach(container => {
          if (container !== videoContainer) {
            const otherVideo = container.querySelector('video');
            if (otherVideo && !otherVideo.paused) {
              console.log('Pausing other video');
              otherVideo.pause();
              container.classList.add('paused');
            }
          }
        });
      }
      
      // Handle play/pause button click
      function handlePlayPause(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Play/pause clicked for section', sectionIndex, 'Video paused:', video.paused);
        
        if (video.paused) {
          // Pause other videos first
          pauseOtherVideos();
          
          // Try to play this video
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              console.log('Video started playing in section', sectionIndex);
              updateVideoState();
            }).catch(error => {
              console.error('Video play failed in section', sectionIndex, ':', error);
              updateVideoState();
            });
          }
        } else {
          console.log('Pausing video in section', sectionIndex);
          video.pause();
          updateVideoState();
        }
      }
      
      // Handle video click
      function handleVideoClick(e) {
        e.preventDefault();
        handlePlayPause(e);
      }
      
      // Remove any existing listeners to prevent duplicates
      const oldPlayPauseHandler = playPauseBtn._productHighlightHandler;
      if (oldPlayPauseHandler) {
        playPauseBtn.removeEventListener('click', oldPlayPauseHandler);
      }
      
      const oldVideoHandler = video._productHighlightHandler;
      if (oldVideoHandler) {
        video.removeEventListener('click', oldVideoHandler);
      }
      
      // Add new listeners
      playPauseBtn.addEventListener('click', handlePlayPause);
      video.addEventListener('click', handleVideoClick);
      
      // Store references for cleanup
      playPauseBtn._productHighlightHandler = handlePlayPause;
      video._productHighlightHandler = handleVideoClick;
      
      // Handle video events
      const eventHandlers = {
        play: () => {
          console.log('Video play event in section', sectionIndex);
          updateVideoState();
        },
        pause: () => {
          console.log('Video pause event in section', sectionIndex);
          updateVideoState();
        },
        ended: () => {
          console.log('Video ended in section', sectionIndex);
          updateVideoState();
        },
        loadstart: () => {
          console.log('Video load start in section', sectionIndex);
          updateVideoState();
        },
        canplay: () => {
          console.log('Video can play in section', sectionIndex);
          updateVideoState();
        },
        error: (e) => {
          console.error('Video error in section', sectionIndex, ':', e);
          updateVideoState();
        }
      };
      
      // Remove existing event listeners if they exist
      Object.keys(eventHandlers).forEach(eventType => {
        const oldHandler = video['_productHighlight_' + eventType];
        if (oldHandler) {
          video.removeEventListener(eventType, oldHandler);
        }
        
        // Add new handler
        video.addEventListener(eventType, eventHandlers[eventType]);
        video['_productHighlight_' + eventType] = eventHandlers[eventType];
      });
      
      // Handle aspect ratio
      function handleAspectRatio() {
        const aspectRatio = getComputedStyle(section).getPropertyValue('--video-aspect-ratio').trim();
        
        if (aspectRatio === 'auto') {
          videoContainer.style.aspectRatio = 'auto';
          if (video.videoWidth && video.videoHeight) {
            const videoAspect = video.videoWidth / video.videoHeight;
            if (videoAspect && !isNaN(videoAspect)) {
              videoContainer.style.aspectRatio = videoAspect.toString();
            }
          }
        } else if (aspectRatio) {
          videoContainer.style.aspectRatio = aspectRatio;
        }
      }
      
      video.addEventListener('loadedmetadata', handleAspectRatio);
      
      // Handle autoplay
      if (video.hasAttribute('autoplay') && (video.muted || video.hasAttribute('muted'))) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Check if no other videos are playing
              const otherVideosPlaying = Array.from(document.querySelectorAll('.tpt-product-highlight-3_video-container video')).some(v => 
                v !== video && !v.paused && !v.ended
              );
              
              if (!otherVideosPlaying) {
                const playPromise = video.play();
                if (playPromise !== undefined) {
                  playPromise.then(() => {
                    console.log('Autoplay started in section', sectionIndex);
                    updateVideoState();
                  }).catch(error => {
                    console.log('Autoplay prevented in section', sectionIndex, ':', error);
                    updateVideoState();
                  });
                }
              }
            } else {
              video.pause();
              updateVideoState();
            }
          });
        }, { threshold: 0.3 });
        
        observer.observe(videoContainer);
      }
      
      // Initial state
      updateVideoState();
      
      // Mark as initialized
      initializedVideos.add(videoContainer);
      console.log('Video initialized for section', sectionIndex);
    }
    
    // Handle all video elements
    function handleVideoElements() {
      const sections = document.querySelectorAll('.tpt-product-highlight-3');
      console.log('Handling video elements for', sections.length, 'sections');
      
      sections.forEach((section, index) => {
        initVideoForSection(section, index);
      });
    }
    
    // Handle window resize to recalculate heights
    function handleResize() {
      const activeContents = document.querySelectorAll('.tpt-product-highlight-3_accordion-item.active .tpt-product-highlight-3_accordion-content');
      
      activeContents.forEach(content => {
        const textElement = content.querySelector('.tpt-product-highlight-3_accordion-text');
        if (textElement) {
          const scrollHeight = textElement.scrollHeight;
          content.style.maxHeight = (scrollHeight + 40) + 'px';
        }
      });
      
      // Update video aspect ratios
      updateVideoAspectRatios();
    }
    
    // Handle aspect ratio changes for dynamic content
    function updateVideoAspectRatios() {
      const videoContainers = document.querySelectorAll('.tpt-product-highlight-3_video-container');
      const videoPlaceholders = document.querySelectorAll('.tpt-product-highlight-3_video-placeholder');
      
      videoContainers.forEach(container => {
        const video = container.querySelector('video');
        const section = container.closest('.tpt-product-highlight-3');
        
        if (video && section) {
          const aspectRatio = getComputedStyle(section).getPropertyValue('--video-aspect-ratio').trim();
          
          if (aspectRatio === 'auto') {
            container.style.aspectRatio = 'auto';
            if (video.videoWidth && video.videoHeight) {
              const videoAspect = video.videoWidth / video.videoHeight;
              if (videoAspect && !isNaN(videoAspect)) {
                container.style.aspectRatio = videoAspect.toString();
              }
            }
          } else if (aspectRatio) {
            container.style.aspectRatio = aspectRatio;
          }
        }
      });
      
      videoPlaceholders.forEach(placeholder => {
        const section = placeholder.closest('.tpt-product-highlight-3');
        if (section) {
          const aspectRatio = getComputedStyle(section).getPropertyValue('--video-aspect-ratio').trim();
          if (aspectRatio && aspectRatio !== 'auto') {
            placeholder.style.aspectRatio = aspectRatio;
          } else {
            placeholder.style.aspectRatio = '1/1';
          }
        }
      });
    }
    
    // Debounce function for resize handler
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    
    // Clean up old event listeners before reinitializing
    function cleanupEventListeners() {
      // Clean up accordion event listeners
      const accordionHeaders = document.querySelectorAll('.tpt-product-highlight-3_accordion-header');
      accordionHeaders.forEach(header => {
        const existingHandler = header._accordionClickHandler;
        if (existingHandler) {
          header.removeEventListener('click', existingHandler);
          delete header._accordionClickHandler;
        }
      });
      
      // Clean up video event listeners
      const playPauseButtons = document.querySelectorAll('.tpt-product-highlight-3_play-pause-btn');
      playPauseButtons.forEach(btn => {
        const existingHandler = btn._productHighlightHandler;
        if (existingHandler) {
          btn.removeEventListener('click', existingHandler);
          delete btn._productHighlightHandler;
        }
      });
      
      const videos = document.querySelectorAll('.tpt-product-highlight-3_video-container video');
      videos.forEach(video => {
        const existingHandler = video._productHighlightHandler;
        if (existingHandler) {
          video.removeEventListener('click', existingHandler);
          delete video._productHighlightHandler;
        }
        
        // Clean up video event handlers
        const eventTypes = ['play', 'pause', 'ended', 'loadstart', 'canplay', 'error'];
        eventTypes.forEach(eventType => {
          const handler = video['_productHighlight_' + eventType];
          if (handler) {
            video.removeEventListener(eventType, handler);
            delete video['_productHighlight_' + eventType];
          }
        });
      });
    }
    
    // Initialize everything
    function initialize() {
      console.log('Initializing Product Highlight 3');
      initProductHighlightAccordion();
      handleVideoElements();
      updateVideoAspectRatios();
    }
    
    // Force reinitialize function (for Shopify editor)
    function forceReinitialize() {
      console.log('Force reinitializing Product Highlight 3');
      cleanupEventListeners();
      // Clear initialization tracking
      initializedSections.clear?.(); // Clear if supported
      initializedVideos.clear?.(); // Clear if supported
      
      // Re-initialize everything
      setTimeout(() => {
        initialize();
      }, 50);
    }
    
    // Initial load
    initialize();
    
    // Handle window resize with debounce
    window.addEventListener('resize', debounce(handleResize, 250));
    
    // Re-initialize when new content is loaded (for Shopify section editor)
    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.tpt-product-highlight-3')) {
          console.log('Shopify section loaded, reinitializing');
          forceReinitialize();
        }
      });
      
      document.addEventListener('shopify:section:reorder', function(event) {
        if (event.target.querySelector('.tpt-product-highlight-3')) {
          console.log('Shopify section reordered, reinitializing');
          forceReinitialize();
        }
      });
      
      document.addEventListener('shopify:section:unload', function(event) {
        if (event.target.querySelector('.tpt-product-highlight-3')) {
          console.log('Shopify section unloaded, cleaning up');
          cleanupEventListeners();
        }
      });
    }
    
    // Handle dynamic content updates
    const observer = new MutationObserver((mutations) => {
      let shouldReinitialize = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasVideoContent = addedNodes.some(node => 
            node.nodeType === Node.ELEMENT_NODE && 
            (node.classList?.contains('tpt-product-highlight-3') ||
             (node.querySelector && node.querySelector('.tpt-product-highlight-3')))
          );
          
          if (hasVideoContent) {
            shouldReinitialize = true;
          }
        }
      });
      
      if (shouldReinitialize) {
        console.log('DOM changed, reinitializing');
        setTimeout(() => {
          handleVideoElements();
          updateVideoAspectRatios();
        }, 100);
      }
    });
    
    // Observe changes to the document
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Make functions available globally for debugging
    window.tptProductHighlight3 = {
      initialize: initialize,
      forceReinitialize: forceReinitialize,
      cleanupEventListeners: cleanupEventListeners
    };
  });